export enum CompStyleId {
  TxtTheme = 'txtTheme',
}
